import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import MaterialTable, { MTableToolbar } from "material-table";
import axios from "axios";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import ContentLoader from "react-content-loader";
import _ from "lodash";
import jsPDF from "jspdf";
// import "jspdf-autotable";
import { autoTable } from 'jspdf-autotable'
import { ToastContainer, toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import AsyncSelect from "react-select/async";

import { API } from "../../backend";
import authHeader from "../../services/auth-header";
import DeletePartyService from "../../services/party/deletePartyService";
import { getTrans as t } from "../../Localization/translations";
import ActivePartyService from "../../services/party/activepartyservice";
import Helper from "../../Helper";
import NotesSingle from "../../components/Notes/NotesSingle";

function Party({ customerPermission }) {
  const tablePartyRef = React.createRef();
  const [planFeatures, setPlanFeatures] = useState(null); 
  const [loading, setLoading] = useState(true);
  const [inputvalue, setValue] = useState("");
  const [selectedValue, setSelectedValue] = useState(null);
  const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);
  const [object_name, setObject_name] = useState('Parties')
  const [selectedRowId, setSelectedRowId] = useState(null);

  const [permissionss, setPermission] = useState(
    localStorage.getItem("permissions")
  );
  const permissionsArray = permissionss.split(",");

  var customerName = "";

  const [state1, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });

  let navigate = useNavigate();

  const handelInputChange = (value) => {
    setValue(value);
  };

  const handelChange = (value) => {
    setSelectedValue(value);
  };

  const loadOptions = async (inputValue) => {
    if (inputValue !== "") {
      const responseJSON = await axios.get(
        API + `parties/party/?customer_name=${inputValue}`,
        { headers: authHeader() }
      );
      return responseJSON.data.data;
    }
  };

  const handleEdit = (id) => {
    navigate("/editparty", { state: id });
  };

  const handleView = (id) => {
    navigate("/party/details", { state: id });
  };

  const handleClear = () => {
    setSelectedValue("");
    tablePartyRef.current.onQueryChange();
  };

  const fetchAllDataForExport = async () => {
    let allData = [];
    let currentPage = 0;
    const pageSize = 10; // Your page size

    while (true) {
      const query = {
        pageSize,
        page: currentPage,
        search: '',
      };

      // Modify the logic here to handle customerName if needed
      let customerName = "";
      if (selectedValue) {
        customerName = selectedValue.customer_name;
      }

      const url = API + "parties/party/?per_page=" + query.pageSize + "&page=" + (query.page + 1) + "&search=" + query.search + "&customerName=" + customerName;

      try {
        const response = await fetch(url, { headers: authHeader() });
        const result = await response.json();

        if (result.data.length === 0) {
          break;
        }

        allData = allData.concat(result.data);
        currentPage++;
      } catch (error) {
        console.error("Error fetching data:", error);
        break;
      }
    }

    return allData;
  };

    useEffect(() => {
      const fetchSubscriptionFeatures = async () => {
        try {
          const response = await axios.get(`${API}paymentsub/subscription/`, {
            headers: authHeader()
          });
          
          if (response.data.success === 1 && response.data.data) {
            setPlanFeatures(response.data.data.plan);
          }
        } catch (error) {
          console.error("Error fetching subscription features:", error);
        }
      };
      fetchSubscriptionFeatures();
    }, []);
    
    const isNotesDisabled = planFeatures && planFeatures.notes === false;
    // console.log("resp == ",planFeatures)
    // console.log("plan features == ",planFeatures)

  useEffect(() => {
    setLoading(false);
  }, []);

  useEffect(() => {
    if (tablePartyRef.current) {
      tablePartyRef.current.onQueryChange();
    }
  }, [tablePartyRef]);

  const handelDelete = (id, status) => {
    confirmAlert({
      title: "",
      message:
        status === "Active"
          ? "Are you sure you want to InActivate this party?."
          : "Are you sure you want to Activate this party?.",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            DeletePartyService.deleteParty(id).then((response) => {
              if (response.data.success) {
                toast.success(`${response.data.response}`, {
                  position: "top-right",
                  autoClose: 1000,
                  hideProgressBar: false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
                tablePartyRef.current.onQueryChange();
              } else {
                toast.error(`${response.data.error}`, {
                  position: "top-right",
                  autoClose: 1000,
                  hideProgressBar: false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
              }
            })
          },
        },
        {
          label: "No",
        },
      ],
    });
  };

  const handelpartyDelete = (id, status) => {
    confirmAlert({
      title: "",
      message: "Are you sure you want to delete this party?.",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            DeletePartyService.PartyPermanentDelete(id).then((response) => {
              if (response.data.success) {
                toast.success(`${response.data.response}`, {
                  position: "top-right",
                  autoClose: 1000,
                  hideProgressBar: false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
                tablePartyRef.current.onQueryChange();
              } else {
                toast.error(`${response.data.error}`, {
                  position: "top-right",
                  autoClose: 1000,
                  hideProgressBar: false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
              }
            })
          },
        },
        {
          label: "No",
        },
      ],
    });
  };

  const handelActive = (id, status) => {
    confirmAlert({
      title: "",
      message:
        status === "Active"
          ? "Are you sure you want to disable this party?."
          : "Are you sure you want to Activate this party?.",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            ActivePartyService.activeParty(id).then((response) => {
              if (response.data.success) {
                toast.success(`${response.data.response}`, {
                  position: "top-right",
                  autoClose: 1000,
                  hideProgressBar: false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
                tablePartyRef.current.onQueryChange();
              } else {
                toast.error(`${response.data.error}`, {
                  position: "top-right",
                  autoClose: 1000,
                  hideProgressBar: false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
              }
            })
          },
        },
        {
          label: "No",
        },
      ],
    });
  };

  function getAlignmentStyles(columns) {
    const alignmentStyles = {};
    columns.forEach((columnDef, index) => {
      if (columnDef.field === 'party_ref' || columnDef.field === 'party_number') {
        alignmentStyles[index] = { halign: 'right' };
      } else {
        alignmentStyles[index] = { halign: 'left' };
      }
    });
    return alignmentStyles;
  }

  return (
    <>
      {loading === false ? (
        <div className="page-wrapper">
          <ToastContainer />
          <div className="content container-fluid">
            <div className="row">
              <div className="">
                <div className="ms-auto my-auto mt-lg-0 mt-4">
                  <div className="ms-auto my-auto"></div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="">
                  <div className="body">
                    <div className="p-0">
                      <MaterialTable
                        tableRef={tablePartyRef}
                        style={{
                          backgroundColor: "var(--bs-table-bg) ",
                          borderBottomWidth: "1px",
                          boxShadow:
                            "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                        }}
                        title={<h5 className="d-lg-flex">{t("Parties")}</h5>}
                        columns={[
                          {
                            title: `${t("Party Name")}`,
                            field: "customer_name",
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                            render: (rowData) => (
                              <>
                                {" "}
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Party Name")}
                                </div>
                                <div
                                  className="hyperlink"
                                  onClick={() =>
                                    permissionss &&
                                      permissionsArray.includes("view_party") ===
                                      true
                                      ? handleView(rowData.id)
                                      : ""
                                  }
                                >
                                  {rowData.customer_name}
                                </div>
                              </>
                            ),
                          },
                          {
                            title: `${t("Party Type")}`,
                            field: "party_type",
                            render: (rowData) => (
                              <>
                                {" "}
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Party Type")}
                                </div>
                                <div>{rowData.party_type}</div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Entity Type")}`,
                            field: "customer_type",
                            render: (rowData) => (
                              <>
                                {" "}
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Entity Type")}
                                </div>
                                <div>{rowData.customer_type}</div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Party Reference")}`,
                            field: "party_ref",
                            render: (rowData) => (
                              <>
                                {" "}
                                <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}>
                                  {t("Party Reference")}
                                </div>
                                <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                  {" "}
                                  {rowData.party_ref !== "null"
                                    ? rowData.party_ref
                                    : "None"}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "right",
                            },
                            // cellStyle: {
                            //   textAlign: "left",
                            //   fontSize: 12,
                            // },
                          },
                          {
                            title: `${t("Party Number")}`,
                            field: "party_number",
                            render: (rowData) => (
                              <>
                                {" "}
                                <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}>
                                  {t("Party Number")}
                                </div>
                                <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                  {" "}
                                  {rowData.party_number && rowData.party_number !== "null"
                                    ? rowData.party_number
                                    : "None"}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "right",
                            },
                          },
                          {
                            title: `${t("sales tax code")}`,
                            field: "sales_tax_code",
                            hidden: true,
                            render: (rowData) => (
                              <>
                                {" "}
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("sales tax code")}
                                </div>
                                <div>
                                  {" "}
                                  {rowData.sales_tax_code !== "null"
                                    ? rowData.sales_tax_code
                                    : "None"}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("ssn tin number")}`,
                            field: "ssn_tin_number",
                            hidden: true,
                            render: (rowData) => (
                              <>
                                {" "}
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("ssn tin number")}
                                </div>
                                <div>
                                  {" "}
                                  {rowData.ssn_tin_number !== "null"
                                    ? rowData.ssn_tin_number
                                    : "None"}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("TIN number")}`,
                            field: "TIN_number",
                            hidden: true,
                            render: (rowData) => (
                              <>
                                {" "}
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("TIN number")}
                                </div>
                                <div>
                                  {" "}
                                  {rowData.TIN_number !== "null"
                                    ? rowData.TIN_number
                                    : "None"}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("date of birth")}`,
                            field: "date_of_birth",
                            hidden: true,
                            render: (rowData) => (
                              <>
                                {" "}
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("date of birth")}
                                </div>
                                <div>
                                  {" "}
                                  {rowData.date_of_birth !== "null"
                                    ? rowData.date_of_birth
                                    : "None"}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("last name")}`,
                            field: "last_name",
                            hidden: true,
                            render: (rowData) => (
                              <>
                                {" "}
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("last name")}
                                </div>
                                <div>
                                  {" "}
                                  {rowData.last_name !== "null"
                                    ? rowData.last_name
                                    : "None"}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("middle name")}`,
                            field: "middle_name",
                            hidden: true,
                            render: (rowData) => (
                              <>
                                {" "}
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("middle name")}
                                </div>
                                <div>
                                  {" "}
                                  {rowData.middle_name !== "null"
                                    ? rowData.middle_name
                                    : "None"}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("first name")}`,
                            field: "first name",
                            hidden: true,
                            render: (rowData) => (
                              <>
                                {" "}
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("first_name")}
                                </div>
                                <div>
                                  {" "}
                                  {rowData.first_name !== "null"
                                    ? rowData.first_name
                                    : "None"}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("establishment date")}`,
                            field: "establishment_date",
                            hidden: true,
                            render: (rowData) => (
                              <>
                                {" "}
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("establishment date")}
                                </div>
                                <div>
                                  {" "}
                                  {rowData.establishment_date !== "null"
                                    ? rowData.establishment_date
                                    : "None"}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("prefix")}`,
                            field: "prefix",
                            hidden: true,
                            render: (rowData) => (
                              <>
                                {" "}
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("prefix")}
                                </div>
                                <div>
                                  {" "}
                                  {rowData.prefix !== "null"
                                    ? rowData.prefix
                                    : "None"}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Status")}`,
                            field: "status",
                            render: (rowData) => (
                              <>
                                {" "}
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Status")}
                                </div>
                                <div>
                                  {" "}
                                  {rowData.status !== "null"
                                    ? rowData.status
                                    : "None"}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Notes")}`,
                            field: "",
                            hidden: customerPermission !== 'Customer' ? false : true,
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Notes")}
                                </div>
                                <div
                                  onClick={() => {
                                    if (isNotesDisabled) return; 
                                    setIsSidePanelOpen(true);
                                    setSelectedRowId(rowData.id);
                                  }}
                                  style={{
                                    opacity: isNotesDisabled ? 0.5 : 1,
                                    cursor: isNotesDisabled ? 'not-allowed' : 'pointer',
                                    filter: isNotesDisabled ? 'grayscale(100%)' : 'none'
                                  }}
                                >
                                    <span className="cursor-pointer">
                                  {rowData.has_notes ?
                                    <img
                                      src={
                                        process.env.PUBLIC_URL +
                                        "/static/assets/img/curved-images/icons8-sticky-notes-96.png"
                                      }
                                      alt="notes"
                                      height='30px'
                                      width='30px'
                                    /> :
                                    <><img
                                        src={process.env.PUBLIC_URL +
                                          "/static/images/iconplus.png"}
                                        alt="notes"
                                        height='22px'
                                        width='22px' /></>
                                      }
                                      {isNotesDisabled && <span style={{fontSize: '10px', marginLeft: '2px'}}>🔒</span>}
                                      </span>
                                </div>
                                {isSidePanelOpen && selectedRowId === rowData.id && (
                                  <NotesSingle
                                    setIsSidePanelOpen={setIsSidePanelOpen}
                                    isSidePanelOpen={isSidePanelOpen}
                                    state={selectedRowId}
                                    object_name={object_name}
                                  />
                                )}
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                        ]}
                        data={(query) =>
                          new Promise((resolve, reject) => {
                            const { orderBy, orderDirection } = query;
                            if (selectedValue) {
                              customerName = selectedValue.customer_name;
                            } else {
                              customerName = "";
                            }
                            let url = API + "parties/party/?";
                            url += "per_page=" + query.pageSize;
                            url += "&page=" + (query.page + 1);
                            url += "&search=" + query.search;
                            url += "&customerName=" + customerName;
                            if (orderBy) {
                              url += `&orderBy=${orderBy.field}`;
                              url += `&orderDirection=${orderDirection}`;
                            }
                            fetch(url, { headers: authHeader() })
                              .then((response) => response.json())
                              .then((result) => {
                                resolve({
                                  data:
                                    query.orderBy && query.orderDirection
                                      ? _.orderBy(
                                        result.data,
                                        [query.orderBy.field],
                                        [query.orderDirection]
                                      )
                                      : result.data,
                                  page: result.page - 1,
                                  totalCount: result.total,
                                });
                              });
                          })
                        }
                        localization={{
                          toolbar: {
                            searchPlaceholder: "Search Party",
                          },
                        }}
                        actions={[
                          {
                            icon: () =>
                              permissionss &&
                                permissionsArray.includes("change_party") ===
                                true ? (
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/static/images/ic-edit.svg"
                                  }
                                  alt="edit"
                                />
                              ) : null,
                            tooltip:
                              permissionss &&
                                permissionsArray.includes("change_party") === true
                                ? "Edit"
                                : "",
                            onClick:
                              permissionss &&
                                permissionsArray.includes("change_party") === true
                                ? (event, rowData) => {
                                  handleEdit(rowData.id);
                                }
                                : "",
                          },
                          (rowData) => ({
                            icon: rowData.status === "Active" ? "block" : "send",
                            tooltip:
                              rowData.status === "Active"
                                ? "InActivate"
                                : "Activate",
                            onClick: (event, rowData) => {
                              rowData.status === "Active"
                                ? handelDelete(rowData.id, rowData.status)
                                : handelActive(rowData.id, rowData.status);
                            },
                          }),
                          (rowData) => ({
                            icon: () => (
                              rowData.has_contract === true || rowData.has_contractasset === true ? "" :
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/static/images/ic-delete.svg"
                                  }
                                  alt="delete"
                                />
                            ),
                            tooltip: "Delete",

                            onClick: (event, rowData) => {
                              handelpartyDelete(rowData.id, rowData.status);
                            },
                            hidden: rowData.has_contract === true || rowData.has_contractasset === true ? true : false,
                            disabled:
                              rowData.has_contract === true || rowData.has_contractasset === true ? true : false,
                          }),
                        ]}
                        components={{
                          Toolbar: (props) => (
                            <div className="MuiToolbar-root MTableToolbar-spacer-21  my-temp-class">
                              <MTableToolbar {...props} />
                              <span
                                onClick={() => setState({ isPaneOpen: true })}
                                style={{
                                  color: "#b4b7c5",
                                  paddingRight: "1px",
                                  cursor: "pointer",
                                }}
                              >
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/static/images/ic-filter.svg"
                                  }
                                  alt="filter"
                                />
                              </span>

                              {permissionss &&
                                permissionsArray.includes("add_party") === true
                                ? customerPermission !== "Customer" && (
                                  <Link
                                    className="navbar-brand m-0"
                                    to="/addnewparty"
                                  >
                                    <button
                                      className="add-party add btn btn-primary  mb-0"
                                      id="add-task"
                                    >
                                      +&nbsp; {t("Add party")}
                                    </button>
                                  </Link>
                                )
                                : ""}
                            </div>
                          ),
                        }}
                        options={{
                          headerStyle: {
                            backgroundColor: "white",
                            color: "#245C7F",
                            fontSize: 12,
                          },
                          rowStyle: (rowData, index) => {
                            if (index % 2) {
                              return { backgroundColor: "#fff" };
                            }
                          },
                          sorting: true,
                          search: true,
                          toolbar: true,
                          paging: true,
                          pageSize: 10, // make initial page size
                          emptyRowsWhenPaging: false, // To avoid of having empty rows
                          pageSizeOptions: [10, 20, 25, 50],
                          paginationType: "stepped",
                          showFirstLastPageButtons: false,
                          exportAllData: true,
                          exportButton: true,
                          exportFileName: "Parties",
                          exportCsv: async (columns, data) => {
                            try {
                              const allData = await fetchAllDataForExport(); // Fetch all data
                              if (selectedValue !== null) {
                                var selectedVal = selectedValue.customer_name
                              }

                              const title = "Parties";
                              const currentDate = new Date().toLocaleDateString();
                              const csvContentWithInfo = `${title}\n ${selectedValue !== null ? `Fiter By Party Name : ${selectedVal}\n ` : ''} Date: ${currentDate}\n \n\n`;
                              const csvColumns = Helper.visibleColumn(columns);
                              const csvColumnTitles = csvColumns.map(column => column.title);
                              const csvData = allData.map(rowData => {
                                const rowDataArray = csvColumns.map(columnDef => {
                                  if (columnDef.field === "customer_name") {
                                    return rowData.customer_name ? rowData.customer_name : "";
                                  } else if (columnDef.field === "party_type") {
                                    return rowData.party_type ? rowData.party_type : "";
                                  } else {
                                    return rowData[columnDef.field];
                                  }
                                });
                                return rowDataArray;
                              });

                              const csvRows = [csvColumnTitles, ...csvData];
                              const csvContent = `${csvContentWithInfo}${csvRows.map(row => row.join(',')).join('\n')}`
                              const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                              const link = document.createElement('a');
                              link.href = URL.createObjectURL(blob);
                              link.download = 'Parties.csv';
                              link.style.display = 'none';
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            } catch (error) {
                              console.error("Error exporting CSV:", error);
                            }
                          },
                          exportPdf: async (columns, data) => {
                            try {
                              const allData = await fetchAllDataForExport(); // Fetch all data
                              const visibleColumns = Helper.visibleColumn(columns);
                              if (allData.length === 0) {
                                console.error("No data found for PDF export");
                                return;
                              }

                              const doc = new jsPDF();
                              doc.setFont("helvetica", "bold");
                              doc.setFontSize(16);

                              const title = "Parties";
                              doc.text(title, 14, 10);

                              doc.setFontSize(12);
                              doc.setFont("helvetica", "normal");
                              const currentDate = new Date().toLocaleDateString();
                              doc.text(`Date : ${currentDate}`, 14, 15);

                              if (selectedValue !== null) {
                                const selectedVal = selectedValue?.customer_name;
                                doc.text(`Filter By Party Name : ${selectedVal === 'undefined' ? '' : selectedVal}`, 14, 20);
                              }
                              const space = 22; // Adjust the space value as needed
                              const tableStartY = 5 + space;

                              const columnTitles = visibleColumns.map(columnDef => columnDef.title);
                              const pdfData = allData.map(rowData =>
                                visibleColumns.map(columnDef => rowData[columnDef.field])
                              );
                              const tableData = [columnTitles, ...pdfData];
                              // doc.autoTable({
                              autoTable(doc,{
                                head: [tableData[0]], // Column headers
                                body: tableData.slice(1), // Data excluding headers
                                startY: tableStartY,
                                columnStyles: getAlignmentStyles(visibleColumns) // Apply column alignment styles
                              });
                              doc.save(`Parties.pdf`);
                            } catch (error) {
                              console.error("Error exporting PDF:", error);
                            }
                          },
                          actionsColumnIndex: -1,
                          columnsButton: true,
                        }}
                      />
                    </div>
                  </div>
                </div>

                <SlidingPane
                  className="some-custom-class"
                  overlayClassName="some-custom-overlay-class"
                  isOpen={state1.isPaneOpen}
                  title="Filter By"
                  subtitle="Party Names"
                  onRequestClose={() => {
                    setState({ isPaneOpen: false });
                  }}
                >
                  <div className="col-md-12">
                    <div className="">
                      <div className="">
                        <div className="col-lg-12 mb-3">
                          <label className="col-lg-12 col-form-label">
                            {t("Party Name")}
                          </label>
                          <AsyncSelect
                            defaultOptions
                            isClearable
                            placeholder={t("Search for Party (%for All)")}
                            value={selectedValue}
                            getOptionLabel={(e) => e.customer_name}
                            getOptionValue={(e) => e.customer_name}
                            loadOptions={loadOptions}
                            onInputChange={handelInputChange}
                            onChange={handelChange}
                          ></AsyncSelect>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-12">
                      <button
                        type="button"
                        className="clearAll btn bg-gradient-secondary ms-auto mb-0 "
                        onClick={handleClear}
                      >
                        {t("Reset")}
                      </button>
                      &nbsp;&nbsp;
                      <button
                        type="button"
                        onClick={() => Helper.handleSearch(tablePartyRef)}
                        className="partyFilter add btn btn-primary ms-auto mb-0"
                      >
                        {t("Apply")}
                      </button>
                      &nbsp;&nbsp;
                    </div>
                  </div>
                </SlidingPane>
              </div>
            </div>
          </div>
          <div
            className="modal right fade"
            id="edit_contact"
            tabIndex="-1"
            role="dialog"
            aria-modal="true"
          ></div>

          <div
            className="modal right fade"
            id="add_party"
            tabIndex="-1"
            role="dialog"
            aria-modal="true"
          ></div>

          <div
            className="modal right fade"
            id="company-details"
            role="dialog"
            aria-modal="true"
          ></div>

          <div
            className="modal right fade"
            id="manage_notification"
            role="dialog"
            aria-modal="true"
          ></div>
        </div>
      ) : (
        <ContentLoader
          viewBox="0 0 1000 550"
          backgroundColor="rgba(0,0,0,0.06)"
          foregroundColor="rgba(0,0,0,0.12)"
        >
          <rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
          <circle cx="879" cy="123" r="11" />
          <circle cx="914" cy="123" r="11" />
          <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
          <rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
          <rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
          <rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
          <circle cx="880" cy="184" r="11" />
          <circle cx="915" cy="184" r="11" />
          <rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
          <rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
          <rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
          <rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
          <circle cx="881" cy="242" r="11" />
          <circle cx="916" cy="242" r="11" />
          <rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
          <rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
          <rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
          <rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
          <circle cx="882" cy="303" r="11" />
          <circle cx="917" cy="303" r="11" />
          <rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
          <rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
          <rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
          <rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
          <circle cx="881" cy="363" r="11" />
          <circle cx="916" cy="363" r="11" />
          <rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
          <rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
          <rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
          <rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
          <circle cx="882" cy="424" r="11" />
          <circle cx="917" cy="424" r="11" />
          <rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
          <rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
          <rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
          <rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
          <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
          <rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
          <circle cx="882" cy="484" r="11" />
          <circle cx="917" cy="484" r="11" />
          <rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
          <rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
          <rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
          <rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
          <rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
          <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
          <rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
          <rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
          <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
          <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
        </ContentLoader>
      )}
    </>
  );
}

export default Party;
